"use client";
import { memo } from "react";
import { FormControl, InputLabel } from "@mui/material";
import AppSelect, { AppSelectProps } from "./AppSelect";

const AppSelectFilter = ({
  label,
  labelId,
  isLoading,
  ...otherProps
}: AppSelectProps) => {
  return (
    <FormControl fullWidth>
      {Boolean(label) && !isLoading && (
        <InputLabel
          sx={{
            "&&.MuiFormLabel-root.MuiInputLabel-root:not(.MuiInputLabel-shrink)":
              { top: "-5px" },
          }}
          id={labelId}
        >
          {label}
        </InputLabel>
      )}
      <AppSelect
        labelId={labelId}
        label={label}
        isLoading={isLoading}
        value={otherProps.value ?? ""}
        {...otherProps}
      />
    </FormControl>
  );
};
AppSelectFilter.displayName = "AppSelectFilter";
export default memo(AppSelectFilter);
